import { makeApiCall, makeApiCallWithImages } from "../apiRequest";

export default {
  state: {
    maintenanceList: [],
  },
  getters: {
    getAllMaintenance: (state) => state.maintenanceList,
  },
  actions: {
    async getAllMaintenance({ commit }, payload) {
      const response = await makeApiCall(
        `superAdminMaintenanceTasks/getAll`,
        "POST",
        payload
      );
      if (!response.error) {
        commit("setMaintenanceList", response.data.data);
      }
      return response;
    },
    async saveMaintenance({ commit }, payload) {
      const response = await makeApiCallWithImages(
        `superAdminMaintenanceTasks/save`,
        "POST",
        payload
      );
      return response;
    },
    async deleteMaintenance({ commit }, payload) {
      const response = await makeApiCall(
        `superAdminMaintenanceTasks/delete`,
        "DELETE",
        payload
      );
      return response;
    },
    async getMaintenanceById({ commit }, payload) {
      const response = await makeApiCall(
        `superAdminMaintenanceTasks/get?id=${payload}`,
        "GET",
        payload
      );
      return response;
    },
  },
  mutations: {
    setMaintenanceList(state, payload) {
      state.maintenanceList = payload;
    },
  },
};
